import React from 'react';
import $ from "jquery";
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Button, Table } from 'semantic-ui-react';

import Title from '../../title';
import Loading from '../../loading';
import getFormatedDate from '../../../functions/date';
import Permission from '../../../functions/permission';
import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';
import MakeDecimalPoints from '../../makedecimalpoints';

export default class HSNCodeReport extends React.Component {

    state = {
        fromDate: getFormatedDate(new Date(), 'fromDate'),
        toDate: getFormatedDate(new Date(), 'toDate'),
        report: [], menuPermission: {}
    }

    componentDidMount() {
        this.menuPermission();
        
    }

    menuPermission() {
        let menuPermission = Permission('hsncode-report', this.props.menus);
        if (menuPermission.view) {
            this.getHSNCodeReport();
            this.setState({ menuPermission })
        }
    }

    getHSNCodeReport = () => {
        let context = this;
        let { fromDate, toDate } = this.state;
        this.setState({ load: true, message: 'FETCHING REPORT!!!!' });
        let data = (ReadCookie("branch"));
        let branch;
        for (var i = 0; i < data.length; i++) {
            branch = data[i].branch_id;
        }
        $.ajax({
            type: 'POST',
            data: { fromDate, toDate, branch },
            url: Server() + 'Accountings/HSNCodeReport/GetReport.php',
            success: function(data) {
                try {
                    data = JSON.parse(data);
                    context.setState({ report: data, load: false })
                } catch (error) {
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                context.setState({ load: false });
            }
        });
    }

    export = () => {
        let downloadLink;
        let filename = 'HSNCodeReport';
        let dataType = 'application/vnd.ms-excel';
        let tableSelect = document.getElementById('export');
        let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
        filename = filename?filename+'.xls':'excel_data.xls';
        downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        if(navigator.msSaveOrOpenBlob) {
          let blob = new Blob(['\ufeff', tableHTML], {
              type: dataType
          });
          navigator.msSaveOrOpenBlob( blob, filename);
        }
        else {
          downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
          downloadLink.download = filename;
          downloadLink.click();
        }
      }

    render() {
        let { openDrawer } = this.props;
        let { load, message, menuPermission, report } = this.state;
        let i = 1;
        return (
            <div>
                <Title title={'HSNCode Report'} openDrawer={openDrawer} />
                <Loading load={load} message={message} />
                { !menuPermission.view ?
                    <center style={{color: 'red'}}>You Are Not Allow To Access This Menu!!!</center>
                    :
                    <div style={{margin: '0.5%'}}>
                        <div style={{display: 'flex'}}>
                            <TextField label="From" type="date"
                            onChange={(e) => this.setState({fromDate: e.target.value})}
                            defaultValue={this.state.fromDate} />

                            <TextField style={{marginLeft: 20}} label="To" type="date"
                            onChange={(e) => this.setState({toDate: e.target.value})}
                            defaultValue={this.state.toDate} />

                            <Button primary onClick={this.getHSNCodeReport} style={{marginLeft: '1%'}}>Submit</Button>

                            <Button onClick={this.export} style={{marginLeft: '1%'}}>Export</Button>

                        </div>
                        <div style={{overflow: 'auto', overflow: 'scroll', width: '98vw', height: '95vh' }}>
                            <Table celled singleLine id='export'>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell id='tableheader'>Sino</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>HSN</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Transaction</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Invoice Number</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Invoice Date</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Customer</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>State</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Branch</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>GST IN</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Part Number</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Brand</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Quantity</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Tax</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Taxable Amount</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Tax Amount</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Other Charges</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>CGST Amount</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>SGST Amount</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>IGST Amount</Table.HeaderCell>
                                        <Table.HeaderCell id='tableheader'>Total Amount</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                { 
                                    report.map((item) => {
                                        return (
                                            <Table.Row>
                                                <Table.Cell>{i++}</Table.Cell>
                                                <Table.Cell>{item.HSN}</Table.Cell>
                                                <Table.Cell>{item.TransactionType}</Table.Cell>
                                                <Table.Cell>{item.InvoiceNumber}</Table.Cell>
                                                <Table.Cell>{item.InvoiceDate}</Table.Cell>
                                                <Table.Cell>{item.customer}</Table.Cell>
                                                <Table.Cell>{item.State}</Table.Cell>
                                                <Table.Cell>{item.Branch}</Table.Cell>
                                                <Table.Cell>{item.GSTIN}</Table.Cell>
                                                <Table.Cell>{item.PartNumber}</Table.Cell>
                                                <Table.Cell>{item.Brand}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'center'}}>{item.Quantity}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'center'}}>{item.TaxStructureName}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(item.TaxableAmount))}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(item.TaxAmount))}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{item.OtherCharges}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(item.CGSTAmount))}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(item.SGSTAmount))}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(item.IGSTAmount))}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(item.TotalAmount))}</Table.Cell>
                                            </Table.Row>
                                        )
                                    })
                                }
                                </Table.Body>
                            </Table>
                        </div>
                    </div>
                }
            </div>
        )
    }
}